module.exports = __webpack_public_path__ + "static/img/kuang.95f80fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/kuang.png
// module id = 2vm0
// module chunks = 0